module.exports = __webpack_public_path__ + "static/home-artist-management-75b0e0a54644b011726056611732099c.png";